import { createClient } from '@supabase/supabase-js';
import { TENANT_SLUG } from './tenant';

// In dev the React server proxies /rest/v1, /auth/v1, etc. to nginx, so
// using window.location.origin keeps API calls on the current subdomain
// (e.g. acme.lvh.me:3000) without CORS hassles.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || window.location.origin;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseAnonKey) {
  throw new Error('Missing REACT_APP_SUPABASE_ANON_KEY');
}

// The X-Tenant-Slug header is read by PostgREST RLS policies to scope
// anon storefront reads to the current tenant. Authenticated requests
// still use the JWT tenant_id claim, so this is harmless for them.
const headers: Record<string, string> = {};
if (TENANT_SLUG) headers['X-Tenant-Slug'] = TENANT_SLUG;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  global: { headers },
});
